import { ref } from "vue";

export function useElementId() {
  const id = ref<string>('element_' + crypto.randomUUID());
  return id;
}
